import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ModalModifier } from './ModalModifier';
import { useParams } from 'react-router';

export const ModalModifiersCategory = ({ category, localModifiers, setLocalModifiers }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dishCategory = localModifiers.find((cat) => cat.id === category.id);
    const isCategoryEmpty = category?.modifier_items?.length === 0;
    const isEveryChecked = isCategoryEmpty? dishCategory : category?.modifier_items?.every((item) => dishCategory?.modifier_items?.some(mod => item.id === mod.id));

    const toggleMenuHandler = () => setIsOpen((prev) => !prev);
    const handleModifier = (e, modCategory) => {
        const checked = e.target.checked;

        setLocalModifiers((prev) => {
            const find = prev.find((item) => item.id === modCategory.id);

            if (!find && checked) {
                return [...prev, modCategory];
            }

            if (find && checked) {
                return prev.map(cat => {
                    if(cat.id === category.id) {
                        return category
                    }
                    return cat
                })
            }

            if (find && !checked) {
                return prev.filter((item) => item.id !== modCategory.id);
            }

            return prev;
        });
    };

    return (
        <div className="max-w-full">
            <div className="overflow-hidden sm:rounded-md my-1 mr-1 bg-gray-50 p-1.5">
                <div className="flex justify-between items-center">
                    <div className="px-2 flex justify-between items-center">
                        <div>
                            <input type="checkbox" name={category.name} id={category.id} defaultChecked={isEveryChecked} checked={isEveryChecked} onChange={(e) => handleModifier(e, category)} height={20} width={44} />
                            <label className="text-sm font-semibold ml-5 cursor-pointer" htmlFor={category.id}>
                                {category.name}
                            </label>
                        </div>
                    </div>
                    <span className="mr-6 cursor-pointer" onClick={toggleMenuHandler}>
                        {isOpen ? <img src="/menuicon/arrow_up.svg" alt="arrow_up" width={9} height={12} /> : <img src="/menuicon/arrow_down.svg" alt="arrow_down" width={9} height={12} />}
                    </span>
                </div>
            </div>
            <div className="items mx-5 m-auto">{isOpen && <ModalModifier category={category} items={category.modifier_items} localModifiers={localModifiers} dishCategory={dishCategory} setLocalModifiers={setLocalModifiers} />}</div>
        </div>
    );
};
